import { Slide } from "@mui/material";
import cn from "classnames";
import useTranslate from "../../hooks/useTranslate";
import UserMenu from "../../components/Controls/Actions/UserMenu/UserMenu";
import { IControlsProps } from "./Controls.props";
import styles from "./Controls.module.scss";

const Controls = ({ header, wideHeader = false, clickHandler, setShowPage, leftSection, rightSection, hint = "", ...props }: IControlsProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Slide direction="down" in={true} mountOnEnter unmountOnExit timeout={500}>
			<header className={styles.container} {...props}>
				<h1
					className={cn(styles.header, {
						[styles.headerWide]: wideHeader,
					})}
				>
					{translate(header)}
				</h1>

				<div className={styles.controls} onClick={clickHandler}>
					<div className={styles.controlsSection}>{leftSection}</div>

					<div className={styles.controlsSection}>
						{rightSection}
						<div>
							<UserMenu hint={hint} setShowPage={setShowPage} />
						</div>
					</div>
				</div>
			</header>
		</Slide>
	);
};

export default Controls;
